export default __webpack_public_path__ + "static/media/learnops-certification.7ab4ff09.svg";